var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBoldS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 26",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.34109 12.7477L0.904369 5.17111C0.301456 4.55652 0 3.84831 0 3.0465C0 2.24434 0.301456 1.53614 0.904369 0.921891C1.50728 0.307296 2.20242 0 2.98977 0C3.77678 0 4.47752 0.313006 5.09198 0.939021L14.5723 10.5976C14.8403 10.8841 15.058 11.2203 15.2255 11.6062C15.393 11.9917 15.4767 12.3756 15.4767 12.758C15.4767 13.1401 15.393 13.524 15.2255 13.9099C15.058 14.2954 14.8403 14.6247 14.5723 14.8977L5.09198 24.5563C4.47752 25.1823 3.7851 25.4867 3.01474 25.4694C2.24437 25.4524 1.55755 25.1368 0.9543 24.5225C0.351387 23.9083 0.0499321 23.2001 0.0499321 22.3979C0.0499321 21.5958 0.351387 20.8876 0.9543 20.2733L8.34109 12.7477Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBoldS);
export default __webpack_public_path__ + "static/media/arrow-right-bold-s.8de77b8aef5162e22eaef21f08168072.svg";
export { ForwardRef as ReactComponent };